import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import SiwAzure from "../../assets/images/banner/siw-azure.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import cs from "./../../assets/images/icons/cs.jpg";
import cv from "./../../assets/images/icons/cv.jpg";
import di from "./../../assets/images/icons/di.jpg";
import vi from "./../../assets/images/icons/vi.jpg";
import st from "./../../assets/images/icons/st.png";
import ts from "./../../assets/images/icons/ts.png";
// import cb from "./../../assets/images/icons/cb.jpg";

const AzureAIServices = () => {
  pageTitle("Azure AI Services");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={SorBanner} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-text">
            <h2>Azure AI Services </h2>
            <img
              src={SiwAzure}
              alt="Microsoft azure"
              className="feature-logo"
            />
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            {/* <span class="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div class="siw-rpa-text">
              <p>
                At SiW, we leverage Microsoft Azure AI Services and proven Azure
                architecture best practices to design and deliver intelligent,
                scalable, and business-ready solutions for our clients. By
                aligning our AI and machine learning products with the Azure
                Well-Architected Framework, we ensure every solution is built
                with strong foundations across performance, security,
                reliability, operational excellence, and cost optimization.
                <br /> This enables us to create practical AI-powered products
                and tailored digital solutions that help clients transform their
                workflows, improve decision-making, and drive innovation with
                confidence.
              </p>
            </div>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated Azure AI Services.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the <strong>Azure AI Services</strong>,
              <br />
              Click 👉{" "}
              <a
                href="https://ai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure AI Services
              </a>
              .
            </p>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-20px" }}>
        <div className="siw-rpa-desc mt-0"></div>
        <div class="siw-rpa-desc">
          <h3 className="pb-2">Key Services</h3>
          <p>
            Explore our Azure AI Services designed to support intelligent
            business solutions:
          </p>

          <ul className="siw-azure-ai-services-list mt-2 mb-4">
            {/* <li>
              Click 👉
              <img
                src={cb}
                alt="Microsoft Azure"
                style={{ height: "25px" }}
              />{" "}
              <a href="/chatbot" alt="Chatbot" className="blinking">
                Chatbot
              </a>{" "}
              – A secure cloud-based AI chatbot solution built on the Microsoft
              Azure ecosystem.
            </li> */}
            <li>
              Click 👉
              <img
                src={cs}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a
                href="/content-safety"
                alt="Content Safety"
                className="blinking"
              >
                Content Safety
              </a>{" "}
              – Detect and moderate harmful, offensive, or risky content across
              text and images.
            </li>
            <li>
              Click 👉
              <img
                src={cv}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a
                href="/computer-vision"
                alt="Computer Vision"
                className="blinking"
              >
                Computer Vision
              </a>{" "}
              – Analyze images to extract insights, identify objects, and
              understand visual content.
            </li>
            <li>
              Click 👉
              <img
                src={di}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a
                href="/document-intelligence"
                alt="Document Intelligence"
                className="blinking"
              >
                Document Intelligence
              </a>{" "}
              – Extract text, key fields, and structured data from invoices,
              forms, and documents.
            </li>
            <li>
              Click 👉
              <img
                src={vi}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a href="/video-indexer" alt="Video Indexer" className="blinking">
                Video Indexer
              </a>{" "}
              – Transform video into searchable insights with speech, faces,
              labels, and summaries.
            </li>
            <li>
              Click 👉
              <img
                src={st}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a
                href="/speech-to-text"
                alt="Speech to Text"
                className="blinking"
              >
                Speech to Text
              </a>{" "}
              – Convert spoken audio into accurate text for transcription and
              analysis.
            </li>
            <li>
              Click 👉
              <img
                src={ts}
                alt="Microsoft azure"
                style={{ height: "25px", margin: "0 5px 0px 10px" }}
              />{" "}
              <a
                href="/text-to-speech"
                alt="Text to Speech"
                className="blinking"
              >
                Text to Speech
              </a>{" "}
              – Convert written text into natural-sounding audio for interactive
              user experiences.
            </li>
          </ul>
        </div>
      </div>

      <FooterOne></FooterOne>
    </>
  );
};
export default AzureAIServices;
